
import axiosClient from "./axiosClient";

const serviceUrl = 'core-manager/authorization';

const authorizationService = {
    // authorization


    // Role
    getListRole: async (page = 1, size = 10) => {
        const url = serviceUrl + `/role/list-role`;
        const params = { page: page, size: size };
        const response = await axiosClient.get(url, { params: params });
        return response;
    },
    editRole: async (params) => {
        const url = serviceUrl + `/role`;
        const response = await axiosClient.put(url, params);
        return response;
    },
    addRole: async (params) => {
        const url = serviceUrl + `/role`;
        const response = await axiosClient.post(url, params);
        return response.data;
    },
    deleteRole: async (id) => {
        const url = serviceUrl + `/role`;
        const params = { id: id }
        const response = await axiosClient.delete(url, { params: params });
        return response.data;
    },

    // API
    getListApi: async (page = 1, size = 10) => {
        const url = serviceUrl + `/api/list-api`;
        const params = { page: page, size: size };
        const response = await axiosClient.get(url, { params: params });
        return response;
    },
    getApi: async (id) => {
        const url = serviceUrl + `/api/${id}`;
        const response = await axiosClient.get(url,);
        return response;
    },
    editApi: async (params) => {
        const url = serviceUrl + `/api`;
        const response = await axiosClient.put(url, params);
        return response;
    },
    addApi: async (params) => {
        const url = serviceUrl + `/api`;
        const response = await axiosClient.post(url, params);
        return response.data;
    },
    deleteApi: async (id) => {
        const url = serviceUrl + `/api`;
        const params = { id: id }
        const response = await axiosClient.delete(url, { params: params });
        return response.data;
    },


    // Chức năng
    getListFunction: async (page = 1, size = 10) => {
        const url = serviceUrl + `/chuc-nang/list-chuc-nang`;
        const params = { page: page, size: size };
        const response = await axiosClient.get(url, { params: params });
        return response;
    },
    getFunction: async (id) => {
        const url = serviceUrl + `/chuc-nang/${id}`;
        const response = await axiosClient.get(url,);
        return response;
    },
    editFunction: async (params) => {
        const url = serviceUrl + `/chuc-nang`;
        const response = await axiosClient.put(url, params);
        return response;
    },
    addFunction: async (params) => {
        const url = serviceUrl + `/chuc-nang`;
        const response = await axiosClient.post(url, params);
        return response.data;
    },
    deleteFunction: async (id) => {
        const url = serviceUrl + `/chuc-nang`;
        const params = { id: id }
        const response = await axiosClient.delete(url, { params: params });
        return response.data;
    },


    // ROLE_Chức năng
    getListRole_Function: async (page = 1, size = 10) => {
        const url = serviceUrl + `/chuc-nang-role/list-chuc-nang-role`;
        const params = { page: page, size: size };
        const response = await axiosClient.get(url, { params: params });
        return response;
    },
    getRole_Function_By_RoleId: async (id) => {
        const url = serviceUrl + `/chuc-nang-role/role-id`;
        const params = { id: id }
        const response = await axiosClient.get(url, { params: params });
        return response;
    },
    getRole_Function_By_FunctionId: async (id) => {
        const url = serviceUrl + `/chuc-nang-role/chuc-nang-id`;
        const params = { id: id }
        const response = await axiosClient.get(url, { params: params });
        return response;
    },
    getRole_Function_By_Id: async (id) => {
        const url = serviceUrl + `/chuc-nang-role/role-id`;
        const params = { id: id }
        const response = await axiosClient.get(url, { params: params });
        return response;
    },
    editRole_Function: async (params) => {
        const url = serviceUrl + `/chuc-nang-role`;
        const response = await axiosClient.put(url, params);
        return response;
    },
    addRole_Function: async (params) => {
        const url = serviceUrl + `/chuc-nang-role`;
        const response = await axiosClient.post(url, params);
        return response;
    },
    deleteRole_Function: async (id) => {
        const url = serviceUrl + `/chuc-nang-role`;
        const params = { id: id }
        const response = await axiosClient.delete(url, { params: params });
        return response.data;
    },


    // API_ROLE
    getListApi_Role: async (page = 1, size = 10) => {
        const url = serviceUrl + `/api-role/list-api-role`;
        const params = { page: page, size: size };
        const response = await axiosClient.get(url, { params: params });
        return response.data;
    },
    getApi_Role_By_RoleId: async (id) => {
        const url = serviceUrl + `/api-role/role-id`;
        const params = { id: id }
        const response = await axiosClient.get(url, { params: params });
        return response;
    },
    getApi_Role_By_ApiId: async (id) => {
        const url = serviceUrl + `/api-role/api-id`;
        const params = { id: id }
        const response = await axiosClient.get(url, { params: params });
        return response;
    },
    getApi_Role_By_Id: async (id) => {
        const url = serviceUrl + `/api-role/role-id`;
        const params = { id: id }
        const response = await axiosClient.get(url, { params: params });
        return response;
    },
    editApi_Role: async (params) => {
        const url = serviceUrl + `/api-role`;
        const response = await axiosClient.put(url, params);
        return response;
    },
    addApi_Role: async (params) => {
        const url = serviceUrl + `/api-role`;
        const response = await axiosClient.post(url, params);
        return response;
    },
    deleteApi_Role: async (id) => {
        const url = serviceUrl + `/api-role`;
        const params = { id: id }
        const response = await axiosClient.delete(url, { params: params });
        return response.data;
    },

};

export default authorizationService;
